export function renderVars(str, args) {
    let next = str;
    Object.keys(args).forEach(k => {
        next = next.replace(`%${k}`, args[k]);
    });
    return next;
}